import { useState, useRef, useEffect } from 'react'
import { Box } from '@mui/material'
import styles from './index.module.scss'

const CLAMP_HEIGHT = 460

export default function UserChatBubbleClamp({ children }) {
  const contentRef = useRef(null)
  const [isTruncated, setIsTruncated] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    const el = contentRef.current
    if (!el) return

    const checkTruncation = () => {
      // We check if the natural height exceeds our clamp height threshold
      if (el.scrollHeight > CLAMP_HEIGHT) {
        setIsTruncated(true)
      } else {
        setIsTruncated(false)
        setIsExpanded(false)
      }
    }

    checkTruncation()

    const observer = new ResizeObserver(() => {
      checkTruncation()
    })
    
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <Box className={`${styles.clampWrapper} ${isTruncated && !isExpanded ? styles.clampCollapsed : ''} ${isExpanded ? styles.clampExpanded : ''}`}>
      <Box className={styles.clampContent} ref={contentRef}>
        {children}
      </Box>
      {isTruncated && !isExpanded && (
        <Box className={styles.clampGradient} aria-hidden="true" />
      )}
      {isTruncated && (
        <Box className={styles.clampToggleWrapper}>
          <button
            type="button"
            className={styles.clampToggleButton}
            onClick={() => setIsExpanded((prev) => !prev)}
            aria-expanded={isExpanded}
          >
            {isExpanded ? 'Collapse' : 'Expand'}
          </button>
        </Box>
      )}
    </Box>
  )
}
